import React, { useState, useEffect } from 'react'
import { Box, Text, Flex, Group, Button, Skeleton, CopyButton, Tooltip, ThemeIcon } from '@mantine/core'
import { IconCheck, IconCopy, IconWindowMaximize } from '@tabler/icons-react'
import { generateUrlPublicOrder } from '../../../../../services/orders'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrderSummary } from '../../../../../store/orderDetail'


const FormShareReviewOrder = ({ idOrder, onCloseModal }) => {
  const dispatch = useDispatch()
  const { summary } = useSelector(state => state.order_detail)
  const apiUrl = process.env.REACT_APP_SERVER_API_URL
  const [loadingSignature, setLoadingSignature] = useState(false)
  const [dataSignature, setDataSignature] = useState(null)

  const generatePublicUrl = async (orderId) => {
    setLoadingSignature(true)
    try {
      const response = await generateUrlPublicOrder(orderId)
      if (response.success) {
        const codeSignature = response.message
        const getSignatureUrl = codeSignature.includes('Successful create temporary url with signature:')
            ? codeSignature.replace('Successful create temporary url with signature:', '')
            : codeSignature.replace('This request quote already has a temporary url with signature:', '')
        
        setDataSignature(getSignatureUrl)
        const updatedSummary = {
          ...summary,
          signature: getSignatureUrl
        }
        dispatch(updateOrderSummary(updatedSummary))
        
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSignature(false)
    }
  }

  useEffect(() => {
    handleSetState(summary)
    // eslint-disable-next-line
  }, [summary])

  const handleSetState = (value) => {
    setDataSignature(value.signature === '' ? null : value.signature)
  }

  const openNewTab = (url) => {
    window.open(`${url}`, '_blank')
  }

  const handleApiUrl = (api) => {
    if (api.includes('api2dev')) {
      return 'https://app-dev.asiacommerce.net'
    } else {
      return 'https://app.asiacommerce.net'
    }
  }

  const mappingSignature = (dataSignature) => {
    if (dataSignature !== null) {
      return (
        <Flex gap={4} align='center'>
          <Text fz={12} c='blue.9'>{`${handleApiUrl(apiUrl)}/review/${dataSignature}/order/${idOrder}`}</Text>
          <CopyButton value={`${handleApiUrl(apiUrl)}/review/${dataSignature}/order/${idOrder}`} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                  {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                </ThemeIcon>
              </Tooltip>
            )}
          </CopyButton>
          <Tooltip label='Open Link' withArrow position="top">
            <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${handleApiUrl(apiUrl)}/review/${dataSignature}/order/${idOrder}`)}>
              <IconWindowMaximize size={12} />
            </ThemeIcon>
          </Tooltip>
        </Flex>
      )
    } else {
      return (
        <Box ta='center'>
          <Button size='compact-xs' variant='transparent' color='blue.9' onClick={() => generatePublicUrl(idOrder)}>Click to Generate URL</Button>
        </Box>
      )
    }
  }

  return (
    <Box>
      <Box mb='lg'>
        <Text fz={14} fw='600' mb={2}>Restricted URL</Text>
        <Text fz={12} fw='500' c='gray.6' mb={1}>Need Login to App</Text>
        <Flex gap={4} align='center'>
          <Text fz={12} c='blue.9'>{`${handleApiUrl(apiUrl)}/order/${idOrder}/review`}</Text>
          <CopyButton value={`${handleApiUrl(apiUrl)}/order/${idOrder}/review`} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="top">
                <ThemeIcon color={copied ? 'teal' : 'blue.9'} variant="subtle" onClick={copy} size='xs'>
                  {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                </ThemeIcon>
              </Tooltip>
            )}
          </CopyButton>
          <Tooltip label='Open Link' withArrow position="top">
            <ThemeIcon color='blue.9' variant="subtle" size='xs' onClick={() => openNewTab(`${handleApiUrl(apiUrl)}/order/${idOrder}/review`)}>
              <IconWindowMaximize size={12} />
            </ThemeIcon>
          </Tooltip>
        </Flex>
      </Box>
      <Box mb='lg'>
        <Text fz={14} fw='600' mb={2}>Public URL (With Limited Time)</Text>
        <Text fz={12} fw='500' c='gray.6' mb={1}>The generated link expired after 24 hours. No need to Login</Text>
        {loadingSignature ? <Box w={100}><Skeleton height={14} radius="xl" /></Box> : mappingSignature(dataSignature)}
        
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormShareReviewOrder